export default __webpack_public_path__ + "static/media/iconoTienda.33e20425.svg";